import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const injectProps = (child, className, propTransform) => {
  const newProps = {
    className: clsx(child.props.className, className),
    ...propTransform(child.props)
  }
  return React.cloneElement(child, newProps)
}

const renderChildren = (children, classes) => {
  const childrenArray = React.Children.toArray(children)
  const count = childrenArray.length

  if (count === 0) {
    return null
  }

  let className = classes.avatarGroup

  if (count === 1) {
    className = classes.avatarSolo
  } else if (count === 2) {
    className = classes.avatarDuo
  }

  return childrenArray.slice(0, 3).map((child, i) => {
    const propTransform = () => {
      if (count > 3 && i === 2) {
        return { user: { name: '..', avatar_id: null } }
      }

      return {}
    }

    return injectProps(child, className, propTransform)
  })
}

const AvatarGroup = ({ children, className }) => {
  const classes = useStyles()

  const count = React.Children.count(children)

  return (
    <div
      className={clsx(
        classes.root,
        count === 2 && classes.groupDuo,
        count > 2 && classes.groupMulti,
        className
      )}
    >
      {renderChildren(children, classes)}
    </div>
  )
}

export default AvatarGroup
